import axios from 'axios';
import * as types from './Reject.types';
import { showNotification } from './../../utils';

const apiUrl = process.env.REACT_APP_API_URL;

export const rejectOrder = (token) => (dispatch, getState) => {
    dispatch({ type: types.REJECT_ORDER, payload: null });
    axios.post(apiUrl + '/uthealth-order/reject-order-by-token', { token },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.REJECT_ORDER_SUCCESS, payload: response.data });

            if (parseInt(response.data ) === 1) {
                showNotification('Success', 'The order was rejected successfully', 'success');
            }
        })
        .catch((error) => {
            showNotification('Error', 'An error has occurred!', 'danger');
        });
}
